//文字コードはutf-8

/* ヘッダーの状態制御
 * - トップ: 透明 + 大ロゴ
 * - スクロール時 / メニュー展開時: 白背景 + 小ロゴ（.header--compact）
========================================================*/
export function initHeaderScroll() {
    const header = document.getElementById('js-header');
    if (!header) return;

    let menuOpen = false;
    const compactStatic = header.classList.contains('header--compact-static');
    const interactionEvents = ['wheel', 'touchstart', 'pointerdown', 'mousedown', 'keydown'];
    const update = () => {
        const compact = compactStatic || menuOpen || window.scrollY > 40;
        header.classList.toggle('header--compact', compact);
    };
    const enableLogoTransition = () => {
        header.classList.remove('header--no-logo-transition');
        interactionEvents.forEach((eventName) => {
            window.removeEventListener(eventName, enableLogoTransition);
        });
    };

    update();
    header.classList.remove('header--logo-pending');
    window.addEventListener('scroll', update, { passive: true });
    interactionEvents.forEach((eventName) => {
        window.addEventListener(eventName, enableLogoTransition, { passive: true });
    });

    // ドロワー開閉に追従（drawer.js から発火）
    document.addEventListener('drawer:toggle', (e) => {
        menuOpen = !!(e.detail && e.detail.open);
        enableLogoTransition();
        update();
    });
}
